import type { ChainIdentifier } from "@opensea/graphql"

const MOONPAY_CURRENCY_CODES: Partial<
  Record<ChainIdentifier, Record<string, string>>
> = {
  ethereum: {
    ETH: "eth",
    USDC: "usdc",
    DAI: "dai",
    WETH: "weth",
    SAND: "sand",
    MANA: "mana",
  },
  polygon: {
    MATIC: "matic_polygon",
    ETH: "eth_polygon",
    USDC: "usdc_polygon",
  },
  arbitrum: {
    ETH: "eth_arbitrum",
    USDC: "usdc_arbitrum",
  },
  optimism: {
    ETH: "eth_optimism",
    USDC: "usdc_optimism",
  },
  base: {
    ETH: "eth_base",
    USDC: "usdc_base",
  },
  avalanche: {
    AVAX: "avax_cchain",
  },
}

export const getMoonPayCurrencyCode = (
  symbol: string,
  chain: ChainIdentifier,
): string | undefined => {
  return MOONPAY_CURRENCY_CODES[chain]?.[symbol]
}

const DEFAULT_MOONPAY_CURRENCY_CODES: Partial<Record<ChainIdentifier, string>> =
  {
    ethereum: "eth",
    polygon: "matic_polygon",
    arbitrum: "eth_arbitrum",
    optimism: "eth_optimism",
    base: "eth_base",
    avalanche: "avax_cchain",
  }

export const getDefaultMoonPayCurrencyCode = (
  chain: ChainIdentifier,
): string | undefined => {
  return DEFAULT_MOONPAY_CURRENCY_CODES[chain]
}
